import React, { useMemo } from 'react'
import { NextPage } from 'next'
import PublicLayout from 'src/components/Layout/public'
import { Section } from 'src/components/Common/Section'
import { colors } from 'src/theme/colors'
import { useRouter } from 'next/router'
import { Title } from 'src/components/Common'
import { CategoryContainer, CategoryModuleSingleWrapper } from 'src/components/Curso/styles'
import TitleWrapper from 'src/components/Common/TitleWrapper'
import { CategoryModules } from 'src/service/api/api.types'
import { apiPrivate } from 'src/service/api/api.private'
import Container from 'src/components/Common/Container'
import { GridSkeleton } from 'src/components/Skeleton/grid'
import { GridWrapper } from 'src/components/Grid/styles'
import { Card } from 'src/components/Common/Card'
import { Button } from 'src/components/Common/Button'
import { FaArrowCircleLeft } from 'react-icons/fa'
import ReadMoreReact from 'read-more-react'
import { RiFolderMusicFill } from 'react-icons/ri'
import { Dialog } from 'src/components/Common/Modal'

export type InfoModule = {
  title: string
  course: string
  module: string
  imageUrl: string
  order?: string
}

const Course: NextPage = () => {
  const router = useRouter()
  const params = router.query as InfoModule
  const [categoryModule, setCategoryModule] = React.useState<CategoryModules>()
  const [isLoading, setIsLoading] = React.useState(false)
  const [isOpen, setIsOpen] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    if (params.module) {
      ;(async () => {
        await fetchModule()
      })()
    }
  }, [params.module, params.order])

  async function fetchModule() {
    setIsLoading(true)
    const res = await apiPrivate.getCategoryModule(params.module, params?.order || 'desc')
    if (res.kind === 'ok') {
      setCategoryModule(res.data)
    }
    setIsLoading(false)
  }

  function handleSelect(order) {
    router.query.order = order
    router.push(router)
  }

  const RenderLessons = useMemo(
    () =>
      function RenderLessonsComponent() {
        if (categoryModule?.lessons && categoryModule?.lessons?.length > 0) {
          return (
            <GridWrapper>
              {categoryModule.lessons.map(item => (
                <div key={`${item.id}`} className="card-grid">
                  <Card
                    imageWidth={276}
                    imageHeight={147}
                    data={item}
                    preset="secondary"
                    linkType="lesson"
                  />
                </div>
              ))}
            </GridWrapper>
          )
        }

        return <></>
      },
    [categoryModule?.lessons],
  )

  const Modal = () => {
    const array =
      categoryModule?.lessons && categoryModule?.lessons?.length > 0
        ? JSON.parse(JSON.stringify(categoryModule.lessons))
        : []
    const orderAlfabetic = array.sort((x, y) => x.title.localeCompare(y.title))
    return (
      <Dialog
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        title={`Confira o catálogo de ${categoryModule?.title.toLocaleLowerCase()}`}
      >
        <div className="catalog">
          <ol>
            {orderAlfabetic.map((item, index) => (
              <li key={`${item.slug}`}>
                <a href={`/curso/aula/${item?.slug}`}>
                  {index + 1}. {item.title}
                </a>
              </li>
            ))}
          </ol>
        </div>
      </Dialog>
    )
  }

  return (
    <PublicLayout showCategory={false}>
      <CategoryContainer>
        <TitleWrapper>
          <Title
            borderMargin="medium"
            size="lg"
            borderColor={colors.palette.white}
            tx={categoryModule?.title || ''}
            iconSource={categoryModule?.category?.iconUrl}
            hasIcon
            hasBorder
            theme="light"
          />
          <Container>
            {false && categoryModule?.description && (
              <small>
                <ReadMoreReact
                  ideal={500}
                  max={500}
                  readMoreText="Clique aqui para ler mais"
                  text={categoryModule?.description}
                />
              </small>
            )}
          </Container>
        </TitleWrapper>
        <Section preset="courses" padding="1rem 0" paddingMobile="1rem 0">
          <Container>
            {isLoading ? (
              <GridSkeleton />
            ) : (
              <CategoryModuleSingleWrapper>
                <div className="filters">
                  <Button
                    type="button"
                    isLink
                    href={`/curso/${categoryModule?.category?.slug}`}
                    labelTx="categoryModule.backToCategory"
                    preset="secondary"
                    LeftAccessory={<FaArrowCircleLeft />}
                  />

                  <Button
                    type="button"
                    labelTx="categoryModule.mustShowCatalog.button"
                    preset="primary"
                    className="button-mustShowCatalog"
                    onClick={() => setIsOpen(true)}
                    LeftAccessory={<RiFolderMusicFill />}
                  />

                  <label htmlFor="filters-order">
                    <strong>Ordenar por:</strong>
                    <select onChange={e => handleSelect(e.target.value)} id="filters-order">
                      <option selected={params?.order === 'desc'} value="desc">
                        Aulas mais recentes
                      </option>
                      <option selected={params?.order === 'asc'} value="asc">
                        Aulas mais antigas
                      </option>
                    </select>
                  </label>
                </div>
                <RenderLessons />
              </CategoryModuleSingleWrapper>
            )}
          </Container>
        </Section>
      </CategoryContainer>

      {isOpen && <Modal />}
    </PublicLayout>
  )
}

export default Course
